import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, Routes } from '@angular/router';
import { ProductviewlistComponent } from './productviewlist.component';
import { OrderaddupdateComponent } from '../orderaddupdate/orderaddupdate.component';
import { EditproductreviewComponent } from '../editproductreview/editproductreview.component';
import { OrderattachmentComponent } from '../editproductreview/orderattachment/orderattachment.component';
import { OrderapprovepdfComponent } from '../editproductreview/orderapprovepdf/orderapprovepdf.component';
import { DetailsproductreviewComponent } from '../detailsproductreview/detailsproductreview.component';
import { DetailattachmentComponent } from '../detailsproductreview/detailattachment/detailattachment.component';
import { DetailapprovepdfComponent } from '../detailsproductreview/detailapprovepdf/detailapprovepdf.component';

const routes: Routes = [

  {
    path: "orderreview",
    component: ProductviewlistComponent,
  },

  {
    path: "orderaddupdate",
    component: OrderaddupdateComponent,
  },

  {
    path: "editproductreview/:id",
    component: EditproductreviewComponent,
    children: [
      {
        path: "orderattachment",
        component: OrderattachmentComponent,
      },
      {
        path: "orderapprovepdf",
        component: OrderapprovepdfComponent,
      },
    ],
  },

  {
    path: "detailsproductreview/:id",
    component: DetailsproductreviewComponent,
    children: [
      {
        path: "detailattachment",
        component: DetailattachmentComponent
      },
      {
        path: "detailapprovepdf",
        component: DetailapprovepdfComponent
      },
    ],
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes), NgbModule],
  exports: [RouterModule]
})

export class OrderreviewRoutingModule { }
